import React, { useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Footer from "./Footer";
import Header from "./Header";
import Scroll from "./Scroll";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import CrackersLoader from "./CrackersLoader";
import { FaTrashAlt, FaShoppingCart, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt, FaCity, FaTag, FaRupeeSign, FaCheck, FaWhatsapp, FaBarcode, FaBox } from "react-icons/fa";
import MobileNavigation from "./MobileNavigation";
import "./cart.css"
import Sticker from "./Sticker";

function Cart() {
  const [cartItems, setCartItems] = useState([]);
  const [discountvalue, setDiscountvalue] = useState();
  const [packagingPercentage, setPackagingPercentage] = useState(0);
  const initialState = {
    firstName: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [minimumOrder, setMinimumOrder] = useState(null);
  const [storeClosed, setStoreClosed] = useState(null);
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 426);

  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [coupondiscount, setCouponDiscount] = useState("");
  const [validCoupons, setValidCoupons] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 426);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("cartItems")) || [];
    setCartItems(items);
  }, []);

  // Form Input Details Local Storage 
  const isFirstRender = useRef(true);

  // Load saved data ONCE
  useEffect(() => {
    const savedData = localStorage.getItem("checkoutFormData");
    if (savedData) {
      setFormData(JSON.parse(savedData));
    }
  }, []);

  // Save ONLY after first render
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    localStorage.setItem("checkoutFormData", JSON.stringify(formData));
  }, [formData]);

  const handleQuantityChange = (product_id, change) => {
    const updatedItems = cartItems.map((item) => {
      if (item.product_id === product_id) {
        const newCount = item.count + change;

        if (newCount < 1) {
          return { ...item, count: 1 };
        }

        // if (newCount > item.stock) {
        //   alert(`Only ${item.stock} item(s) available in stock.`);
        //   return item;
        // }

        return { ...item, count: newCount };
      }
      return item;
    });

    setCartItems(updatedItems);
    localStorage.setItem("cartItems", JSON.stringify(updatedItems));

    const updatedCounts = updatedItems.reduce((acc, item) => {
      acc[item.product_id] = item.count;
      return acc;
    }, {});

    saveCountsToLocalStorage(updatedCounts);
  };

  const handleDelete = (product_id) => {
    const updatedItems = cartItems.filter(
      (item) => item.product_id !== product_id
    );

    localStorage.setItem("cartItems", JSON.stringify(updatedItems));
    setCartItems(updatedItems);
    localStorage.removeItem(`count_${product_id}`);

    const totalUniqueProductCount = updatedItems.length;
    localStorage.setItem("cartCount", totalUniqueProductCount);
    saveCountsToLocalStorage(updatedItems);
  };

  const calculateTotal = (price, count) => {
    if (!price) {
      return "0.00";
    }

    const sanitizedPrice = parseFloat(price.toString().replace(/[^\d.-]/g, ""));
    if (isNaN(sanitizedPrice)) {
      return "0.00";
    }

    return (count * sanitizedPrice).toFixed(2);
  };

  const getSubtotal = () => {
    return cartItems
      .reduce((total, item) => {
        return total + parseFloat(calculateTotal(item.oldprice, item.count));
      }, 0)
      .toFixed(2);
  };

  const getDiscountAmount = () => {
    const subtotal = cartItems.reduce((total, item) => {
      if (item.is_non_discount === "0") {
        const discount = Math.round(discountvalue);
        const itemTotal = parseFloat(calculateTotal(item.oldprice, item.count));
        const discountedItemTotal = (itemTotal * discount) / 100;
        return total + discountedItemTotal;
      } else {
        return total;
      }
    }, 0);

    return subtotal.toFixed(2);
  };

  // NET TOTAL after discount (before packaging)
  const getNetTotal = () => {
    const subtotal = parseFloat(getSubtotal());
    const discountAmount = parseFloat(getDiscountAmount());
    let netTotal = subtotal - discountAmount;

    // Apply coupon discount if available
    if (isCouponApplied && coupondiscount > 0) {
      netTotal = netTotal - (netTotal * coupondiscount / 100);
    }

    return netTotal.toFixed(2);
  };

  const getCouponDiscountAmount = () => {
    const netTotalBeforeCoupon = parseFloat(getSubtotal()) - parseFloat(getDiscountAmount());
    return (netTotalBeforeCoupon * (coupondiscount / 100)).toFixed(2);
  };

  const getPackagingCharge = () => {
    const netTotal = parseFloat(getNetTotal());
    const packagingAmount = (netTotal * parseFloat(packagingPercentage || 0)) / 100;
    return packagingAmount.toFixed(2);
  };

  const grandTotal = () => {
    const netTotal = parseFloat(getNetTotal());
    const packagingAmount = parseFloat(getPackagingCharge());
    const finalTotal = netTotal + packagingAmount;
    return finalTotal.toFixed(2);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber" && !/^\d*$/.test(value)) {
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(formData).forEach((key) => {
      if (key !== "email" && key !== "pincode" && key !== "state" && key !== "address" && key !== "city" && !formData[key]) {
        errors[key] = "This field is required.";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOrderSuccess = () => {
    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartCount");
    const productKeys = Object.keys(localStorage).filter((key) =>
      key.startsWith("count_")
    );
    productKeys.forEach((key) => localStorage.removeItem(key));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const loadAllData = async () => {
      try {
        const homeRes = await axios.post(`${API_BASE_URL}home.php`);
        const { body } = homeRes.data;

        if (body) {
          const storeInfo = body.minimum_order_store_closed?.[0];
          if (storeInfo) {
            setMinimumOrder(storeInfo.minimum_order);
            setStoreClosed(storeInfo.store_closed);
          }

          if (typeof body.coupen_code === "string") {
            setValidCoupons(body.coupen_code.split(',').map(code => code.trim().toUpperCase()));
          } else if (Array.isArray(body.coupen_code) && typeof body.coupen_code[0] === "string") {
            setValidCoupons(body.coupen_code[0].split(',').map(code => code.trim().toUpperCase()));
          }

          setDiscountvalue(body.discount_value?.[0]?.discount_value || 0);
          setCouponDiscount(body.coupen_percentage || 0);
          setPackagingPercentage(body.package_charge_percentage || 0);
        }
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAllData();
  }, []);

  const handleCouponChange = (e) => {
    setCouponCode(e.target.value.trim().toUpperCase());
    setErrorMessage("");
    setIsCouponApplied(false);
  };

  const applyCoupon = () => {
    if (!couponCode) {
      setErrorMessage("Please enter a Referral ID.");
      setIsCouponApplied(false);
      return;
    }

    const formattedCoupon = couponCode.toUpperCase();
    if (validCoupons.includes(formattedCoupon)) {
      setIsCouponApplied(true);
      setErrorMessage("");
    } else {
      setErrorMessage("Invalid referral ID. Please enter a valid one.");
      setIsCouponApplied(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);

      const packagingCharge = parseFloat(getPackagingCharge());
      const finalTotal = parseFloat(grandTotal());

      const orderData = {
        name: formData.firstName,
        email: formData.email,
        phonenumber: formData.mobileNumber,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        pincode: formData.pincode ?? 0,
        subtotal: getSubtotal(),
        discount: getDiscountAmount(),
        discount_percentage: discountvalue,
        net_total: getNetTotal(),
        coupon_discount: isCouponApplied ? getCouponDiscountAmount() : "0.00",
        total: finalTotal,
        coupen_code: isCouponApplied ? couponCode : "",
        packaging_charge: packagingCharge,
        product: cartItems.map((item) => ({
          product_id: item.product_id,
          category_id: item.category_id || "",
          product_name: item.product_name,
          product_code: item.product_code || "",
          unit_price: item.oldprice,
          quantity: item.count,
          final_price: calculateTotal(item.oldprice, item.count),
          discount: item.is_non_discount === "0" ? discountvalue : 0
        })),
      };

      try {
        const response = await axios.post(`${API_BASE_URL}order.php`, orderData);
        console.log("Full API Response:", response);
        console.log("Response data:", response.data);

        let orderId = null;

        if (response.data && response.data.order_id) {
          orderId = response.data.order_id;
        } else if (response.data && response.data.body && response.data.body.order_id) {
          orderId = response.data.body.order_id;
        } else if (response.data && response.data.body) {
          orderId = response.data.body.order_id || response.data.body[0]?.order_id;
        } else {
          orderId = `TEMP_${Date.now()}`;
        }

        console.log("Order ID to pass:", orderId);

        alert("Order placed successfully!");

        if (orderId) {
          navigate(`/thanks?order_id=${orderId}`);
        } else {
          navigate("/thanks");
        }

        handleOrderSuccess();
        localStorage.removeItem("checkoutFormData");
        setFormData(initialState);

      } catch (error) {
        console.error("There was an error placing the order!", error);
        alert("Failed to place order. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const saveCountsToLocalStorage = (data) => {
    if (Array.isArray(data)) {
      data.forEach((item) => {
        localStorage.setItem(`count_${item.product_id}`, item.count);
      });
    } else {
      Object.entries(data).forEach(([product_id, count]) => {
        localStorage.setItem(`count_${product_id}`, count);
      });
    }
    window.dispatchEvent(new Event("storage"));
  };

  if (isLoading) {
    return <CrackersLoader />;
  }

  return (
    <div className="mathi-cart-page">
      <Header />

      {/* Cart Header */}
      <div className="cart-header-section">
        <div className="cart-content-wrapper">
          <div className="cart-header-content text-center py-4">
            <FaShoppingCart className="cart-header-icon" />
            <h1 className="cart-title">Your Shopping Cart</h1>
            <p className="cart-subtitle">
              Review your items and proceed to checkout
            </p>
            <div className="cart-items-count">
              <span className="badge bg-primary">{cartItems.length} items</span>
            </div>
          </div>
        </div>
      </div>

      <Sticker />

      <div className="cart-content-wrapper">
        {/* Cart Items Table */}
        <div className="cart-table-section mb-4">
          <div className="table-responsive">
            <Table className="mathi-cart-table">
              <thead className="cart-table-head" style={{ "--bs-table-bg": 'red' }}>
                <tr className="cart-table-head" style={{ background: 'red' }}>
                  <th className="text-center color-white">Image</th>
                  <th className="text-center color-white">Product Name</th>
                  {!isSmallScreen && <th className="text-center color-white">Product Code</th>}
                  {!isSmallScreen && <th className="text-center color-white">Price</th>}
                  {!isSmallScreen && <th className="text-center color-white">Quantity</th>}
                  <th className="text-center color-white">Total</th>
                  <th className="text-center color-white">Del</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.length === 0 ? (
                  <tr>
                    <td colSpan={isSmallScreen ? 4 : 7} className="text-center py-5">
                      <div className="empty-cart">
                        <FaShoppingCart className="empty-cart-icon" />
                        <h5>Your cart is empty</h5>
                        <p>Add some products to get started!</p>
                        <Link to="/" className="btn btn-primary">
                          Continue Shopping
                        </Link>
                      </div>
                    </td>
                  </tr>
                ) : (
                  cartItems.map((item) => {
                    const isNonDiscount = parseInt(item.is_non_discount, 10) === 1;

                    return (
                      <tr key={item.product_id} className="cart-item-row">
                        <td className="cart-item-image">
                          <img
                            src={item.image}
                            alt={item.product_name}
                            loading="lazy"
                            className="img-thumbnail"
                            style={{ width: "60px", height: "60px", objectFit: "contain" }}
                          />
                        </td>
                        <td className="cart-item-details">
                          <h6 className="cart-item-name">{item.product_name}</h6>
                          {isSmallScreen && item.product_code && (
                            <div className="product-code-mobile mt-1">
                              <span className="badge bg-secondary" style={{ fontSize: "11px" }}>
                                <FaBarcode size={10} className="me-1" />
                                Code: {item.product_code}
                              </span>
                            </div>
                          )}
                          {isSmallScreen && (
                            <div className="mobile-price-qty mt-2">
                              <div className="mobile-price">
                                {isNonDiscount ? (
                                  <span className="current-price">
                                    <i className="bi bi-currency-rupee"></i> {item.oldprice}
                                  </span>
                                ) : (
                                  <>
                                    <del className="old-price me-2">
                                      <i className="bi bi-currency-rupee"></i>
                                      {item.oldprice}
                                    </del>
                                    <span className="current-price">
                                      <i className="bi bi-currency-rupee"></i>
                                      <span className="Amount">{item.price}</span>
                                    </span>
                                  </>
                                )}
                              </div>
                              <div className="mobile-quantity mt-2">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => handleQuantityChange(item.product_id, -1)}
                                >
                                  -
                                </Button>
                                <span className="quantity-display mx-2">{item.count}</span>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => handleQuantityChange(item.product_id, 1)}
                                >
                                  +
                                </Button>
                              </div>
                            </div>
                          )}
                        </td>
                        {!isSmallScreen && (
                          <td className="cart-item-code text-center">
                            {item.product_code ? (
                              <span className="badge bg-info text-dark">
                                <FaBarcode size={12} className="me-1" />
                                {item.product_code}
                              </span>
                            ) : (
                              <span className="text-muted">—</span>
                            )}
                          </td>
                        )}
                        {!isSmallScreen && (
                          <td className="cart-item-price text-center">
                            {isNonDiscount ? (
                              <span className="current-price">
                                <i className="bi bi-currency-rupee"></i> {item.oldprice}
                              </span>
                            ) : (
                              <>
                                <del className="old-price">
                                  <i className="bi bi-currency-rupee"></i> {item.oldprice}
                                </del>
                                <br />
                                <span className="current-price">
                                  <i className="bi bi-currency-rupee"></i> {item.price}
                                </span>
                              </>
                            )}
                          </td>
                        )}
                        {!isSmallScreen && (
                          <td className="cart-item-quantity">
                            <div className="quantity-control">
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => handleQuantityChange(item.product_id, -1)}
                              >
                                -
                              </Button>
                              <span className="quantity-number mx-2">{item.count}</span>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => handleQuantityChange(item.product_id, 1)}
                              >
                                +
                              </Button>
                            </div>
                          </td>
                        )}
                        <td className="cart-item-total text-center">
                          <span className="item-total fw-bold">
                            <i className="bi bi-currency-rupee"></i>
                            {calculateTotal(
                              isNonDiscount ? item.oldprice : item.price,
                              item.count
                            )}
                          </span>
                        </td>
                        <td className="cart-item-action text-center">
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDelete(item.product_id)}
                            title="Remove item"
                            className="delete-button"
                          >
                            <FaTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {/* Cart Summary and Checkout */}
        <div className="row">
          <div className="col-lg-8">
            <Card className="cart-form-card shadow-sm">
              <Card.Body>
                <div className="form-header mb-4">
                  <div className="form-icon">
                    <FaUser />
                  </div>
                  <h4>Customer Details</h4>
                  <p className="text-muted">Fill in your information to proceed</p>
                </div>

                <Form noValidate>
                  <Row className="g-3">
                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaUser className="me-2" /> Full Name <span style={{color:"red"}}>*</span>
                        </label>
                        <Form.Control
                          type="text"
                          name="firstName"
                          placeholder="Enter your full name"
                          value={formData.firstName}
                          onChange={handleChange}
                          isInvalid={!!formErrors.firstName}
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.firstName}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaPhone className="me-2" /> Mobile Number <span style={{color:"red"}}>*</span>
                        </label>
                        <Form.Control
                          type="tel"
                          name="mobileNumber"
                          placeholder="Enter 10-digit mobile number"
                          value={formData.mobileNumber}
                          onChange={handleChange}
                          isInvalid={!!formErrors.mobileNumber}
                          maxLength={10}
                          pattern="[0-9]*"
                          required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.mobileNumber}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaEnvelope className="me-2" /> Email Address
                        </label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter your email"
                          value={formData.email}
                          onChange={handleChange}
                          // isInvalid={!!formErrors.email}
                          className="form-control-lg"
                        />
                        {/*
                        <Form.Control.Feedback type="invalid">
                          {formErrors.email}
                        </Form.Control.Feedback>
                        */}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaMapMarkerAlt className="me-2" /> Address 
                        </label>
                        <Form.Control
                          as="textarea"
                          name="address"
                          placeholder="Enter your complete address"
                          rows={3}
                          value={formData.address}
                          onChange={handleChange}
                          // isInvalid={!!formErrors.address}
                          // required
                          className="form-control-lg"
                        />
                        {/* <Form.Control.Feedback type="invalid">
                          {formErrors.address}
                        </Form.Control.Feedback> */}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">
                          <FaCity className="me-2" /> City 
                        </label>
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="Enter your city"
                          value={formData.city}
                          onChange={handleChange}
                          // isInvalid={!!formErrors.city}
                          // required
                          className="form-control-lg"
                        />
                        {/* <Form.Control.Feedback type="invalid">
                          {formErrors.city}
                        </Form.Control.Feedback> */}
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="form-group">
                        <label className="form-label">State </label>
                        <Form.Control
                          type="text"
                          name="state"
                          placeholder="Enter your state"
                          value={formData.state}
                          onChange={handleChange}
                          // isInvalid={!!formErrors.state}
                          // required
                          className="form-control-lg"
                        />
                        <Form.Control.Feedback type="invalid">
                          {formErrors.state}
                        </Form.Control.Feedback>
                      </div>
                    </Col>

                    <Col md={6}>
                    <label className="form-label">Pincode </label>
                      <Form.Control
                        type="text"
                        name="pincode"
                        placeholder="Enter 6-digit pincode"
                        value={formData.pincode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                          setFormData({
                            ...formData,
                            pincode: value,
                          });
                        }}
                        maxLength={6}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        // isInvalid={!!formErrors.pincode}
                        // required
                        className="form-control-lg"
                      />
                      {/* <Form.Control.Feedback type="invalid">
                          {formErrors.pincode}
                        </Form.Control.Feedback> */}
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>

          <div className="col-lg-4">
            <Card className="cart-summary-card shadow-sm">
              <Card.Body>
                <div className="summary-header mb-4">
                  <h4>Order Summary</h4>
                  <p className="text-muted">Review your order details</p>
                </div>

                {/* Order Summary - Correct Order: Subtotal → Discount → Net Total → Packing Charge → Grand Total */}
                <div className="order-summary mb-4">
                  <h6 className="summary-title">Price Details</h6>
                  <div className="summary-items">
                    {/* 1. Subtotal */}
                    <div className="summary-item d-flex justify-content-between">
                      <span>Subtotal</span>
                      <span className="fw-bold">
                        <i className="bi bi-currency-rupee"></i> {getSubtotal()}
                      </span>
                    </div>

                    {/* 2. Discount */}
                    <div className="summary-item d-flex justify-content-between">
                      <span>Discount ({Math.round(discountvalue)}%)</span>
                      <span className="text-success">
                        - <i className="bi bi-currency-rupee"></i> {getDiscountAmount()}
                      </span>
                    </div>

                    {/* 3. Net Total (after discount, before packaging) */}
                    <div className="summary-item d-flex justify-content-between border-bottom pb-2">
                      <span className="fw-semibold">Net Total</span>
                      <span className="fw-bold text-primary">
                        <i className="bi bi-currency-rupee"></i> {getNetTotal()}
                      </span>
                    </div>

                    {/* Referral/Coupon Discount (if applied) */}
                    {isCouponApplied && coupondiscount > 0 && (
                      <div className="summary-item d-flex justify-content-between mt-2">
                        <span>Referral Discount ({coupondiscount}%)</span>
                        <span className="text-success">
                          - <i className="bi bi-currency-rupee"></i> {getCouponDiscountAmount()}
                        </span>
                      </div>
                    )}

                    {/* 4. Packaging Charge */}
                    {packagingPercentage > 0 && (
                      <div className="summary-item d-flex justify-content-between">
                        <span>
                          <FaBox className="me-1" /> Packaging Charge ({packagingPercentage}%)
                        </span>
                        <span>
                          <i className="bi bi-currency-rupee"></i> {getPackagingCharge()}
                        </span>
                      </div>
                    )}

                    {/* 5. Grand Total */}
                    <div className="summary-total d-flex justify-content-between mt-3 pt-3 border-top">
                      <span className="fw-bold fs-5">Grand Total</span>
                      <span className="fw-bold fs-5 text-primary">
                        <i className="bi bi-currency-rupee"></i> {grandTotal()}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Minimum Order Check - Attractive Animated Box with Simple Text */}
                {storeClosed === "1" ? (
                  <div className="alert alert-danger" role="alert">
                    <h6>Store Closed</h6>
                    <p className="mb-0">Our store is currently closed. Please try again later.</p>
                  </div>
                ) : (
                  <>
                    {/* {parseFloat(grandTotal()) < 3000 ? (
                      <div className="animated-min-order-container">
                        <div className="animated-min-order-box">
                          <div className="animated-min-order-text">
                            Minimum order amount 3000
                          </div>
                        </div>
                      </div>
                    ) : ( */}
                      <Button
                        variant="primary"
                        size="lg"
                        className="w-100 mb-3"
                        onClick={handleSubmit}
                        disabled={loading || cartItems.length === 0}
                      >
                        {loading ? (
                          <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Processing...
                          </>
                        ) : (
                          <>
                            <FaWhatsapp className="me-2" />
                            Confirm Your Order
                          </>
                        )}
                      </Button>
                    {/* )} */}
                  </>
                )}

                {/* Cart Info */}
                <div className="cart-info mt-4">
                  <div className="info-item d-flex align-items-center mb-2">
                    <div className="info-icon me-2">
                      <FaShoppingCart />
                    </div>
                    <div className="info-text">
                      <small className="text-muted">
                        {cartItems.length} item(s) in cart
                      </small>
                    </div>
                  </div>
                  <div className="info-item d-flex align-items-center">
                    <div className="info-icon me-2">
                      <FaTag />
                    </div>
                    <div className="info-text">
                      <small className="text-muted">
                        {Math.round(discountvalue)}% discount applied on eligible items
                      </small>
                    </div>
                  </div>
                  {packagingPercentage > 0 && (
                    <div className="info-item d-flex align-items-center mt-2">
                      <div className="info-icon me-2">
                        <FaBox />
                      </div>
                      <div className="info-text">
                        <small className="text-muted">
                          {packagingPercentage}% packaging charge applied
                        </small>
                      </div>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>

      <MobileNavigation />
      <Scroll />
    </div>
  );
}

export default Cart;